// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__qNQ62","switch__btn":"Button_switch__btn__f94QV","switch__btnActive":"Button_switch__btnActive__cbT0A"};